export const OPENTEXT_LOOKUP_CODE = 'OPENTEXT_DOCUMENTS_IMPORT';

export enum EAdministrationOpenTextFieldsService {
  P_DATE_FROM = 'P_DATE_FROM',
  P_DATE_TO = 'P_DATE_TO',
  P_DOC_IDS = 'P_DOC_IDS',
}
